import { build } from 'vite';
import { resolve } from 'path';
import { existsSync, mkdirSync } from 'fs';
import { AutoRouter } from '../routing/autoRouter.js';
import { buildStaticPages } from '../renderer/ssgBuilder.js';

interface BuildConfig {
    appDir: string;
    outDir: string;
    mode: 'ssg' | 'ssr';
}

export async function buildApp(config: BuildConfig) {
    const { appDir, outDir, mode } = config;

    console.log(`🏗️  Construyendo aplicación en modo ${mode.toUpperCase()}...`);

    // Verificar que existe la carpeta app
    if (!existsSync(appDir)) {
        console.error(`❌ No se encontró la carpeta ${appDir}`);
        process.exit(1);
    }

    // Crear directorio de salida
    if (!existsSync(outDir)) {
        mkdirSync(outDir, { recursive: true });
    }

    try {
        // Escanear rutas
        const router = new AutoRouter(appDir);
        const routes = await router.scanRoutes();

        console.log(`📁 Encontradas ${routes.length} rutas:`);
        routes.forEach(route => {
            console.log(`  - ${route.path} (${route.component})`);
        });

        if (mode === 'ssg') {
            // Build estático (SSG)
            await buildStaticPages(routes, null as any, outDir);
            console.log('✅ Build SSG completado');
        } else {
            // Build para SSR
            await buildViteApp(outDir);
            console.log('✅ Build SSR completado');
        }

        console.log(`🎉 Aplicación construida en: ${outDir}`);

    } catch (error) {
        console.error('❌ Error durante el build:', error);
        process.exit(1);
    }
}

async function buildViteApp(outDir: string) {
    await build({
        configFile: false,
        build: {
            outDir,
            emptyOutDir: true,
            rollupOptions: {
                input: {
                    main: resolve(process.cwd(), 'src/main.tsx')
                }
            }
        }
    });
}
